import { RouteObject } from "react-router-dom";

import { GENERAL_ROUTES } from "../../routes";

export const OpportunityAuditRoutes: RouteObject[] = [
  {
    path: GENERAL_ROUTES.OpportunityAudit,
    lazy: async () => {
      const { OpportunityAuditRoute } =
        await import("@src/features/opportunityAudit/OpportunityAudit.route");
      return {
        element: <OpportunityAuditRoute />,
      };
    },
  },
];
